const translations = {
    ru: {
        type: 'Тип сделки',
        assetId: 'ID Актива',
        leverage: 'Плечо',
        openPrice: 'Цена открытия',
        closePrice: 'Цена закрытия',
        priceChange: '% изменения цены',
        volume: 'Объем',
        takeProfit: 'Take Profit',
        stopLoss: 'Stop Loss',
        margin: 'Маржа',
        profit: 'Прибыль',
        closedAt: 'Дата закрытия',
        createdByAdmin: 'Создано админом',
        createdAt: 'Дата открытия'
    },
    en: {
        type: 'Deal Type',
        assetId: 'Asset ID',
        leverage: 'Leverage',
        openPrice: 'Open Price',
        closePrice: 'Close Price',
        priceChange: '% Price Change',
        volume: 'Volume',
        takeProfit: 'Take Profit',
        stopLoss: 'Stop Loss',
        margin: 'Margin',
        profit: 'Profit',
        closedAt: 'Close Date',
        createdByAdmin: 'Created By Admin',
        createdAt: 'Open Date'
    },

};

export const getOrderFormFields = (langSelected) => {
    const currentTranslation = translations[langSelected] || translations.ru;

    return [
        { key: 'type', label: currentTranslation.type, type: 'dropdown', options: [{ value: 'BUY', label: 'BUY' }, { value: 'SELL', label: 'SELL' }], editable: true, required: true },
        { key: 'assets_id', label: currentTranslation.assetId, type: 'input', editable: false, required: true, min: 1, step: '1' },
        { key: 'leverage', label: currentTranslation.leverage, type: 'input', editable: true, required: true, min: 1, step: '1' },
        { key: 'open_price', label: currentTranslation.openPrice, type: 'input', editable: true, required: true, min: 0, step: '0.0001' },
        { key: 'close_price', label: currentTranslation.closePrice, type: 'input', editable: true, required: true, min: 0, step: '0.0001' },
        { key: 'price_change_percent', label: currentTranslation.priceChange, type: 'input', editable: true, required: false, step: '0.0001' },
        { key: 'volume', label: currentTranslation.volume, type: 'input', editable: true, required: true, min: 0.01, step: '0.01' },
        { key: 'take_profit_price', label: currentTranslation.takeProfit, type: 'input', editable: true, required: false, step: '0.0001' },
        { key: 'stop_loss_price', label: currentTranslation.stopLoss, type: 'input', editable: true, required: false, step: '0.0001' },
        { key: 'margin', label: currentTranslation.margin, type: 'input', editable: true, required: false, min: 0, step: '0.01' },
        { key: 'profit', label: currentTranslation.profit, type: 'text', editable: false },
        { key: 'closed_at', label: currentTranslation.closedAt, type: 'datetime-local', editable: true },
        { key: 'created_by_admin', label: currentTranslation.createdByAdmin, type: 'text', editable: false },
        { key: 'created_at', label: currentTranslation.createdAt, type: 'datetime-local', editable: true }
    ];
};
